module.exports = __webpack_public_path__ + "static/media/6.98199145.jpg";